import {Stack, Typography,} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";

interface Props {
    // onNewsletterAccountCreated: (response: string) => void
    // userEmail: string
    // onlyTransactionalMails?: boolean
}

const NewsletterSetup = (props: Props) => {

    const navigate = useNavigate()
    const {t} = useTranslation()
    const readOnlyUser = useReadOnly()

    return (
        <Stack
            alignItems={'center'}
            gap={2}
        >
            <Typography variant={'h4'}>
                {t('Newsletter account not set up yet')}
            </Typography>

            <Button
                variant={'contained'}
                onClick={() => {
                    navigate(`/system/newsletterAccount`)
                }}
                disabled={readOnlyUser}
            >
                {t('Set up newsletter account')}
            </Button>
        </Stack>
    )

    // const [newsletterAccount, setNewsletterAccount] = useState({locale: MAILEON_LANGS[0].code} as NewsletterAccount);
    // const [saving, setSaving] = useState(false)
    // const [responseDialogOpen, setResponseDialogOpen] = useState(false)
    // const [creationResponseMessage, setCreationResponseMessage] = useState('')
    // const {t} = useTranslation()
    //
    // const queryClient = useQueryClient();
    // const navigate = useNavigate()
    //
    //
    // const [activeStep, setActiveStep] = useState(0);
    //
    // const handleNext = () => {
    //     setActiveStep(1);
    // };
    //
    // const handleBack = () => {
    //     setActiveStep(0);
    // };
    //
    // const fetchNewsletterAccountInfo = async (userEmail: string) => {
    //     const res = await NewsletterService.getSavedNewsletterAccountInfo(userEmail);
    //     if (res) {
    //         return {
    //             customerAccountName: res.customerAccountName,
    //             newsletterAccountName: res.newsletterAccountName,
    //             customDomain: res.newsletterAccountDomain,
    //             locale: MAILEON_LANGS.find(l => l.code === res.language)?.code || MAILEON_LANGS[0].code,
    //         };
    //     }
    //     return null;
    // };
    //
    // const {data: savedNewsletterAccount} = useQuery(['savedNewsletterAccountInfo', props.userEmail], () => fetchNewsletterAccountInfo(props.userEmail));
    //
    // useEffect(() => {
    //     if (savedNewsletterAccount) {
    //         setNewsletterAccount(savedNewsletterAccount);
    //     }
    // }, [savedNewsletterAccount]);
    //
    //
    // return (
    //     <Box sx={{width: '100%', typography: 'body1'}}>
    //         <Box sx={{p: 3}}>
    //             {activeStep === 0 &&
    //                 <NewsletterAccountNameSetup
    //                     newsletterAccount={newsletterAccount}
    //                     setNewsletterAccount={setNewsletterAccount}
    //                     handleNext={handleNext}
    //                     activeStep={0}
    //                     onlyTransactionalMails={props.onlyTransactionalMails}
    //                 />
    //             }
    //             {activeStep === 1 &&
    //                 <DnsSettings
    //                     newsletterAccount={newsletterAccount}
    //                     setNewsletterAccount={setNewsletterAccount}
    //                     handleBack={handleBack}
    //                     activeStep={1}
    //                     onNewsletterAccountCreated={props.onNewsletterAccountCreated}
    //                     userEmail={props.userEmail}
    //                 />
    //             }
    //         </Box>
    //     </Box>
    // )
}

export default NewsletterSetup
